import { SIGNALS } from '@/constants/SIGNALS.ts'

class PubSubSingleton implements PubSub {
  private static instance: PubSubSingleton | null = null
  private subscribers: { [key: string]: Callback[] } = {}
  public Signals: Signals = SIGNALS

  private constructor() {}

  public static getInstance(): PubSubSingleton {
    if (!PubSubSingleton.instance) {
      PubSubSingleton.instance = new PubSubSingleton()
    }
    return PubSubSingleton.instance
  }

  subscribe(message: string, callback: Callback): void {
    if (!this.subscribers[message]) {
      this.subscribers[message] = []
    }
    this.subscribers[message].push(callback)
  }

  unsubscribe(message: string, callback: Callback): void {
    if (this.subscribers[message]) {
      this.subscribers[message] = this.subscribers[message].filter((cb) => cb !== callback)
      if (this.subscribers[message].length === 0) {
        delete this.subscribers[message]
      }
    }
  }

  publish(message: string, ...args: unknown[]): void {
    if (this.subscribers[message]) {
      for (const callback of this.subscribers[message]) {
        try {
          callback(...args)
        } catch (err) {
          setTimeout(() => {
            throw err
          })
        }
      }
    }
  }

  reset(): void {
    this.subscribers = {}
  }
}

export const GlobalPubSub = PubSubSingleton.getInstance()
